import dayjs from 'dayjs';
import React from 'react';
import { IExpense } from '../../../@types';
import { formatMoney } from '../../../utils';

interface ExpenseDocumentProps {
  expense: IExpense[];
}

const ExpenseDocument: React.FC<ExpenseDocumentProps> = ({ expense }) => {
  const totalAmount = expense.reduce((acc, curr) => acc + Number(curr.amount), 0);

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4 text-center">Expens Report</h1>
      {expense.map((item) => (
        <div key={item.id} className="mb-6">
          <div className="flex mb-2 mx-auto">
            <div className="w-20 mr-2">
              {' '}
              nn
              <strong>Date:</strong>
            </div>
            <div className="mx-auto">{dayjs(item.createdAt).format('DD MMMM, YYYY')}</div>
          </div>
          <div className="flex mb-2 mx-auto">
            <div className="w-20 mr-2">
              <strong>Category:</strong>
            </div>
            <div className="mx-auto">{item.category}</div>
          </div>
          <div className="flex mb-2 mx-auto">
            <div className="w-20 mr-2">
              <strong>Description:</strong>
            </div>
            <div className="mx-auto">{item.description}</div>
          </div>
          <div className="flex mb-2 mx-auto">
            <div className="w-20 mr-2">
              <strong>Amount:</strong>
            </div>
            <div className="mx-auto">{formatMoney(item.amount)}</div>
          </div>
          <div className="flex mb-2 mx-auto">
            <div className="w-20 mr-2">
              <strong>Vendor:</strong>
            </div>
            <div className="mx-auto">{item.vendor}</div>
          </div>
        </div>
      ))}
      <p className="text-lg font-bold mx-auto">
        <strong>Total Amount:</strong> {formatMoney(totalAmount.toString())}
      </p>
    </div>
  );
};

export { ExpenseDocument };
